export const aa = 1;

export const adUnits = [{
  key: 11730599,
  name: 'AMC',
  selected: false,
}, {
  key: 11730607,
  name: 'ntp_banner',
  selected: false,
}, {
  key: 11728888,
  name: 'US_Edge_NTP_Amplify_Coachmar',
  selected: false,
}, {
  key: 11726287,
  name: 'US_MSN_Edge_NTP_Amplify_river',
  selected: false,
}, {
  key: 11726288,
  name: 'US_MSN_Edge_NTP_Amplify_rr',
  selected: false,
}, {
  key: 11726289,
  name: 'US_winweb_Amplify_river ',
  selected: false,
}, {
  key: 11726290,
  name: 'US_winweb_Amplify_rr ',
  selected: false,
}, {
  key: 11730596,
  name: 'Windows Action Center ',
  selected: false,
}, {
  key: 11730598,
  name: 'Windows Spotlight ',
  selected: false,
}, {
  key: 11730597,
  name: 'Windows Start Menu ',
  selected: false,
}, {
  key: 11730608,
  name: 'windows_10_feed',
  selected: false,
}, {
  key: 11730609,
  name: 'windows_11_feed',
  selected: false,
}, {
  key: 198842086,
  name: 'Edge Marketing Banner',
  selected: false,
}];
